var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-xs text-gray-300 leading-5 py-1 px-4",class:_vm.customClasses},[_c('fa-icon',{staticClass:"mr-2",attrs:{"fixed-width":"","icon":"clock"}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.timeString)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }